module.exports = {
  apiKey: 'AIzaSyC5OnVN2XmA_PS3I7fww6L2W9V1y94dBEE',
  authDomain: 'myungsoo-d735c.firebaseapp.com',
  databaseURL: 'https://myungsoo-d735c.firebaseio.com',
  projectId: 'myungsoo-d735c',
  storageBucket: 'myungsoo-d735c.appspot.com',
  messagingSenderId: '104679062824',
};
